export const SET_HRES63U_INDEX_DISP = 'SET_HRES63U_INDEX_DISP'
export const GET_HRES63U_INDEX_DISP = 'GET_HRES63U_INDEX_DISP'
export const SET_HRES63U_DETAIL_DISP = 'SET_HRES63U_DETAIL_DISP'
export const GET_HRES63U_DETAIL_DISP = 'GET_HRES63U_DETAIL_DISP'
export const SET_HRES63U_COLUMNS = 'SET_HRES63U_COLUMNS'
export const GET_HRES63U_COLUMNS = 'GET_HRES63U_COLUMNS'
export const SET_HRES63U_LABELS = 'SET_HRES63U_LABELS'
export const GET_HRES63U_LABELS = 'GET_HRES63U_LABELS'
export const RECEIVED_HRES63U_COLUMNS_LABELS = 'RECEIVED_HRES63U_COLUMNS_LABELS'
export const SET_HRES63U_INDEX = 'SET_HRES63U_INDEX'
export const GET_HRES63U_INDEX = 'GET_HRES63U_INDEX'
export const RECEIVED_HRES63U_INDEX = 'RECEIVED_HRES63U_INDEX'
export const SET_HRES63U_INDEX_SELECTED = 'SET_HRES63U_INDEX_SELECTED'
export const GET_HRES63U_INDEX_SELECTED = 'GET_HRES63U_INDEX_SELECTED'
export const SET_HRES63U_DETAIL = 'SET_HRES63U_DETAIL'
export const GET_HRES63U_DETAIL = 'GET_HRES63U_DETAIL'
export const RECEIVED_HRES63U_DETAIL = 'RECEIVED_HRES63U_DETAIL'
export const POST_HRES63U_SEND_APPROVE = 'POST_HRES63U_SEND_APPROVE'
export const TOGGLE_HRES63U_PAGE = 'TOGGLE_HRES63U_PAGE'



// WEBPACK FOOTER //
// ./src/store/modules/hres63u/mutation-types.js